import Vue from 'vue'
import Vuex from 'vuex'
Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    // 菜单
    menus: [],
    // 账号分组
    accountGroup: [],
    setSeeAll: ''
  },
  getters: {
  },
  mutations: {
    // 更新菜单
    setMenus(state, data) {
      state.menus = data
    },
    setSeeAll(state, data) {
      state.setSeeAll = data
    },
    // 更新账号分组
    setAccountGroup(state, data) {
      state.accountGroup = data
    },
    removeMenus(state) {
      state.menus = []
    }
  },
  actions: {
    // 更新菜单
    setMenus({ commit }, data) {
      commit('setMenus', data)
    },
    setSeeAll({ commit }, data) {
      commit('setSeeAll', data)
    },
    // 更新账号分组
    setAccountGroup({ commit }, data) {
      commit('setAccountGroup', data)
    },
    // 注销
    removeMenus({ commit }) {
      commit('removeMenus')
    }
  },
  modules: {
  }
})
